<app-modal>
  <app-create-entity [campaignId]="data.campaignId"
                     [initialEntityTypeId]="data.initialEntityTypeId"
                     (entityAdded)=entityAdded($event)></app-create-entity>
</app-modal>
